import React from "react";
import { contactImage } from "../mock";

const whatsappIcon = (
  <svg
    viewBox="0 0 32 32"
    className="w-7 h-7"
    fill="#2D6A4F"
    aria-hidden="true"
  >
    <path d="M16 3C9 3 3.5 8.5 3.5 15.5c0 2.5.7 4.8 1.9 6.8L3 29l6.9-2.3c1.9 1 4 1.6 6.1 1.6 7 0 12.5-5.5 12.5-12.5S23 3 16 3zm0 22.7c-1.9 0-3.7-.5-5.3-1.5l-.4-.2-4.1 1.4 1.4-4-.3-.4c-1.1-1.7-1.7-3.6-1.7-5.5 0-5.7 4.7-10.4 10.4-10.4S26.4 9.8 26.4 15.5 21.7 25.7 16 25.7zm5.7-7.8c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.7.1-.1.3-.4.5-.6.2-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.2-.7-1.7-1-2.3-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1.1 1.1-1.1 2.6s1.1 3 1.3 3.2c.2.2 2.2 3.4 5.4 4.8.8.3 1.4.5 1.8.7.8.3 1.5.2 2 .1.6-.1 1.9-.8 2.2-1.5.3-.8.3-1.4.2-1.5-.1-.2-.3-.3-.6-.5z" />
  </svg>
);

const Contact = () => {
  return (
    <section id="contact" className="bg-white py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-[1300px] mx-auto">
        <h2
          className="text-[40px] md:text-[56px] leading-[1.05] font-semibold text-[#0E0E10] tracking-tight max-w-[700px] mb-6"
          style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
        >
          <span className="italic font-normal">Our team</span> is on hand to
          help.
        </h2>
        <p className="text-[17px] md:text-[18px] text-[#4A4A4D] leading-relaxed max-w-[640px] mb-10">
          Whether you need CIS payroll set up, a compliance review, or just
          some friendly advice — we're here for you.
        </p>

        <a
          href="#contact"
          className="inline-flex items-center gap-2 bg-[#0E0E10] text-white px-6 py-3 rounded-full font-medium hover:bg-[#6B7C61] transition-colors mb-12"
        >
          <span>🤙</span> Time to get in touch?
        </a>

        <div className="bg-[#6B7C61] rounded-[32px] p-5 md:p-8 grid md:grid-cols-[auto_1fr] gap-6 md:gap-10 items-center">
          <div className="w-full md:w-[280px] aspect-square rounded-3xl overflow-hidden bg-sky-200">
            <img
              src={contactImage}
              alt="Construction workers"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="text-white py-2 md:py-4 space-y-6">
            <div>
              <p className="uppercase text-xs tracking-widest text-[#EAF2E8] mb-1">
                Ready to chat?
              </p>
              <p
                className="text-[28px] md:text-[38px] font-light tracking-tight"
                style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
              >
                Give us a ring on{" "}
                <a
                  href="tel:01245493832"
                  className="underline underline-offset-4 decoration-2 hover:text-[#2D6A4F] transition-colors"
                >
                  01245 493832
                </a>
              </p>
            </div>

            {/* <div>
              <p className="uppercase text-xs tracking-widest text-[#EAF2E8] mb-1">
                Prefer to text?
              </p>
              <p
                className="text-[26px] md:text-[34px] font-light flex items-center gap-3 tracking-tight"
                style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
              >
                {whatsappIcon}
                Send us a{" "}
                <a
                  href="https://wa.me/447719065177"
                  className="underline underline-offset-4 decoration-2 hover:text-[#2D6A4F] transition-colors"
                >
                  Whatsapp
                </a>
              </p>
            </div> */}

            <div>
              <p className="uppercase text-xs tracking-widest text-[#EAF2E8] mb-1">
                Short on time?
              </p>
              <p
                className="text-[26px] md:text-[34px] font-light tracking-tight"
                style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
              >
                Email us at{" "}
                <a
                  href="mailto:info@eebs.co.uk"
                  className="underline underline-offset-4 decoration-2 hover:text-[#2D6A4F] transition-colors break-all"
                >
                  compliance@eebssolutions.co.uk
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
